module.exports = "/_next/static/images/envelope-line-a01db4fbf3fad864f998b3f713787afa.svg";